import { defineMessages } from 'react-intl';

const messages: {
	addError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	alertFiltersHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	alertIsBetween: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deleteError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	disabled: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	disableError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	editError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	elseIf: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	elseIfSentenceCase: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	enabled: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	enabledLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	enableError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fieldRequired: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	filterAlerts: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	forAny: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	if: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ifSentenceCase: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	invalidCharacter: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	maxNameCharacter: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	name: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	namePlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nameRequired: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	policiesTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	policyAdded: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	policyDelete: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	policyEdit: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reorderError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requiredFieldsAreMarked: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	saveViewError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	successTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teams: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	then: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thenSentenceCase: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	policiesTitle: {
		id: 'eoc.policies.common-messages.policies.title.no-translate',
		defaultMessage: 'Policies',
		description: 'The heading text displayed at the top of the policies page.',
	},
	errorTitle: {
		id: 'eoc.policies.flag.error-title.no-translate',
		defaultMessage: 'Error',
		description: 'Title of error message that will be displayed in the flag',
	},
	successTitle: {
		id: 'eoc.policies.flag.success-title.no-translate',
		defaultMessage: 'Success',
		description: 'Title of success message that will be displayed in the flag',
	},
	disabled: {
		id: 'eoc.policies.common.disabled.no-translate',
		defaultMessage: 'OFF',
		description:
			'The text shown in a lozenge badge to indicate that a policy is currently disabled (turned off).',
	},
	enabled: {
		id: 'eoc.policies.common.enabled.no-translate',
		defaultMessage: 'ON',
		description:
			'The text shown in a lozenge badge to indicate that a policy is currently enabled (turned on).',
	},
	if: {
		id: 'eoc.policies.common.if.no-translate',
		defaultMessage: 'IF',
		description:
			'The keyword label displayed before the first condition in a policy rule card, indicating the start of a conditional block.',
	},
	ifSentenceCase: {
		id: 'eoc.policies.common.if-sentence-case.no-translate',
		defaultMessage: 'If',
		description:
			'The keyword label displayed before the first condition in a policy rule card, indicating the start of a conditional block.',
	},
	elseIf: {
		id: 'eoc.policies.common.else-if.no-translate',
		defaultMessage: 'ELSE IF',
		description:
			'The keyword label displayed before subsequent conditions in a policy rule card, indicating an additional conditional branch.',
	},
	elseIfSentenceCase: {
		id: 'eoc.policies.common.else-if-sentence-case.no-translate',
		defaultMessage: 'Else if',
		description:
			'The keyword label displayed before subsequent conditions in a policy rule card, indicating an additional conditional branch.',
	},
	then: {
		id: 'eoc.policies.common.then.no-translate',
		defaultMessage: 'THEN',
		description: 'The indicator of what gonna happen after conditions end',
	},
	thenSentenceCase: {
		id: 'eoc.policies.common.then-sentence-case.no-translate',
		defaultMessage: 'Then',
		description: 'The indicator of what gonna happen after conditions end',
	},
	forAny: {
		id: 'eoc.policies.common.rule-card-content.for-any-received-alert.no-translate',
		defaultMessage: 'for any received alert',
		description:
			'The text shown in a rule card condition when no specific alert filter is applied, meaning the rule applies to all incoming alerts.',
	},
	alertIsBetween: {
		id: 'eoc.policies.common.rule-card-content.alert-is-between.no-translate',
		defaultMessage: 'alert time is between ',
		description: 'A text message that will be exist when alert is time restricted',
	},
	reorderError: {
		id: 'eoc.policies.common.flag.reorder-error.no-translate',
		defaultMessage: `We couldn't reorder {type, select,
      global {global}
      other {}
    } alert policies.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while reordering the alert policies',
	},
	enableError: {
		id: 'eoc.policies.common.flag.enable-error.no-translate',
		defaultMessage: `We couldn't turn on the alert policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while changing alert policy state',
	},
	disableError: {
		id: 'eoc.policies.common.flag.disable-error.no-translate',
		defaultMessage: `We couldn't turn off the alert policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while changing alert policy state',
	},
	deleteError: {
		id: 'eoc.policies.common.flag.delete-error.no-translate',
		defaultMessage: `We couldn't delete the alert policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while deleting alert policy',
	},
	addError: {
		id: 'eoc.policies.common.flag.create-error.no-translate',
		defaultMessage: `We couldn't create the {type, select,
      notification {notification}
      other {alert}
    } policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while adding alert policy',
	},
	editError: {
		id: 'eoc.policies.common.flag.edit-error.no-translate',
		defaultMessage: `We couldn't update the {type, select,
      notification {notification}
      other {alert}
    } policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while adding alert policy',
	},
	saveViewError: {
		id: 'eoc.policies.common.flag.save-view-error.no-translate',
		defaultMessage: `We couldn't save the view preferences`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while saving the view preferences',
	},
	policyAdded: {
		id: 'eoc.policies.common.flag.policy-added.no-translate',
		defaultMessage: `{type, select,
      global {Global alert}
      notification {Notification}
      other {Alert}
    } policy "{name}" created.`,
		description: 'Title of success message that will be displayed in the flag after policy created',
	},
	teams: {
		id: 'eoc.policies.common.breadcrumb.teams.no-translate',
		defaultMessage: 'Teams',
		description: 'The text will be displayed on the breadcrumb for Team list navigation',
	},
	policyEdit: {
		id: 'eoc.policies.common.flag.policy-edit.no-translate',
		defaultMessage: `{type, select,
      global {Global alert}
      notification {Notification}
      other {Alert}
    } policy "{name}" updated.`,
		description: 'Title of success message that will be displayed in the flag after policy updated',
	},
	policyDelete: {
		id: 'eoc.policies.common.flag.notification-policy-delete.no-translate',
		defaultMessage: `{type, select,
      global {Global alert}
      notification {Notification}
      other {Alert}
    } policy "{name}" deleted.`,
		description: 'Title of success message that will be displayed in the flag after policy deleted',
	},
	name: {
		id: 'eoc.policies.common.policy-modal.name.no-translate',
		defaultMessage: 'Name',
		description: 'The label for the name input field in the policy creation or edit modal.',
	},
	namePlaceholder: {
		id: 'eoc.policies.common.policy-modal.name-placeholder.no-translate',
		defaultMessage: 'Enter a name for your policy',
		description:
			'The placeholder text shown inside the name input field in the policy modal before the user enters a value.',
	},
	description: {
		id: 'eoc.policies.common.policy-modal.description.no-translate',
		defaultMessage: 'Description',
		description: 'The label for the description input field in the policy creation or edit modal.',
	},
	descriptionPlaceholder: {
		id: 'eoc.policies.common.policy-modal.description-placeholder.no-translate',
		defaultMessage: 'Enter a description for your policy',
		description:
			'The placeholder text shown inside the description input field in the policy modal before the user enters a value.',
	},
	alertFiltersHeading: {
		id: 'eoc.policies.common.policy-modal.alert-filters-heading.no-translate',
		defaultMessage: 'Alert filters',
		description:
			'The section heading displayed above the alert filters configuration area in the policy modal.',
	},
	filterAlerts: {
		id: 'eoc.policies.common.policy-modal.filter-alerts.no-translate',
		defaultMessage: 'Filter alerts',
		description:
			'The label for the alert filtering toggle or section in the policy modal, allowing users to restrict which alerts the policy applies to.',
	},
	fieldRequired: {
		id: 'eoc.policies.common.policy-modal.field-required.no-translate',
		defaultMessage: 'This field is required',
		description: 'Error message that shown required input is empty',
	},
	nameRequired: {
		id: 'eoc.policies.common.policy-modal.name-field-required.no-translate',
		defaultMessage: 'Enter a name',
		description: 'Error message that shown required name input is empty',
	},
	invalidCharacter: {
		id: 'eoc.policies.common.policy-modal.invalid-character.no-translate',
		defaultMessage: 'Enter a name with only alphanumeric characters, dots, underscores, or dashes',
		description: 'Error message that shown required name input has invalid characters',
	},
	maxNameCharacter: {
		id: 'eoc.policies.common.policy-modal.max-name-character.no-translate',
		defaultMessage: 'Name should not be longer than 100 characters',
		description:
			'Error message that shown required name input length is longer than 100 characters',
	},
	enabledLabel: {
		id: 'eoc.policies.common.policy-modal.enabled-label.no-translate',
		defaultMessage: 'Turn on policy now',
		description:
			'The label for the checkbox in the policy modal that allows the user to immediately activate the policy upon saving.',
	},
	requiredFieldsAreMarked: {
		id: 'eoc.policies.common.policy-modal.required-fields-are-marked.no-translate',
		defaultMessage: 'Required fields are marked with an asterisk <asterisk></asterisk>',
		description: 'The accessibility text that indicates there is required fields',
	},
});

export default messages;
